import { Component, Vue, Watch, Prop, Inject } from 'vue-property-decorator';
import style from './style.vue';
@Component({
  components: {},
  mixins: [style],
})
export default class HoverIcons extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  @Prop({ default: 0 })
    bottomHieght: number;

  @Prop({ default: false })
    disabled: boolean;

  @Prop({ default: 124 })
    position: number;

  @Prop()
    fromPage: number;

  @Prop()
    showButton: boolean;

  onClick() {
    this.$emit('click');
  }

  delHoverIcon() {
    this.$emit('del');
  }

  renderLableAndDel(h) {
    return [
      <div class="label-button">悬浮图标</div>,
      <div class="del-button" onClick={this.delHoverIcon.bind(this)}>
        删除
      </div>,
    ];
  }

  render(h) {
    return (
      <div class={[this.value.isActived && 'is-actived', 'hover-icon']} style={`right: ${this.position}px;bottom: ${this.showButton && this.fromPage === 3 ? 98 : 62}px`} onClick={this.onClick.bind(this)}>
        {this.value.isActived && this.value.desc.list && !!this.value.desc.list.length && this.renderLableAndDel(h)}
        {this.value.desc.list.map((v, i) => {
          return (
            <div class="hover-icon-item" key={i}>
              {v.url && <img src={v.url} class="height-100 width-100" />}
            </div>
          );
        })}
      </div>
    );
  }
}
